import riot from 'riot'
import types from './types'

class Store {
  constructor(dispatcher) {
    const self = this
    riot.observable(self)

    // attech event
    self.dispatcher = dispatcher

    // reducer
    self.dispatcher.on(types.SET_TILE, (data) => {
      self.commit({
        name: "tiles",
        data: data
      })
    })

    // initState
    self.state = {
      tiles: []
    }
  }

  getters() {
    return this.state
  }

  commit(opts) {
    const self = this
    self.state[opts.name] = opts.data
    self.trigger('onchange')
  }

  // setTile(data) {
  //   const self = this
  //   self.tiles.push(data)
  //   self.trigger('onchange')
  // }

}

export default Store




// WEBPACK FOOTER //
// ./_src/riot/store/store.js